'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var FunctionTreeError = exports.FunctionTreeError = function (_extendableBuiltin2) {
  _inherits(FunctionTreeError, _extendableBuiltin2);

  function FunctionTreeError(error) {
    _classCallCheck(this, FunctionTreeError);

    var _this = _possibleConstructorReturn(this, (FunctionTreeError.__proto__ || Object.getPrototypeOf(FunctionTreeError)).call(this, error.message || error));

    _this.name = 'FunctionTreeError';
    return _this;
  }

  _createClass(FunctionTreeError, [{
    key: 'toJSON',
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        stack: this.stack
      };
    }
  }]);

  return FunctionTreeError;
}(_extendableBuiltin(Error));

var FunctionTreeExecutionError = exports.FunctionTreeExecutionError = function (_FunctionTreeError) {
  _inherits(FunctionTreeExecutionError, _FunctionTreeError);

  function FunctionTreeExecutionError(execution, funcDetails, payload, error) {
    _classCallCheck(this, FunctionTreeExecutionError);

    var _this2 = _possibleConstructorReturn(this, (FunctionTreeExecutionError.__proto__ || Object.getPrototypeOf(FunctionTreeExecutionError)).call(this, error));

    _this2.name = 'FunctionTreeExecutionError';
    _this2.execution = execution;
    _this2.funcDetails = funcDetails;
    _this2.payload = payload;
    return _this2;
  }

  _createClass(FunctionTreeExecutionError, [{
    key: 'toJSON',
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        execution: {
          name: this.execution.name
        },
        funcDetails: {
          name: this.funcDetails.name,
          functionIndex: this.funcDetails.functionIndex
        },
        payload: this.payload,
        stack: this.stack
      };
    }
  }]);

  return FunctionTreeExecutionError;
}(FunctionTreeError);
//# sourceMappingURL=errors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/function-tree/lib/errors.js
// module id = 230
// module chunks = 0